import { useState } from "react";
import { ShoppingCart, Volume2, VolumeX } from "lucide-react";
import { useCart } from "../context/CartContext";
import { scrollToId } from "../lib/lenis";
import { beep, setHum } from "../lib/sound";

const LINKS = [
  { label: "ENTRANCE", target: "#entrance", id: "entrance" },
  { label: "CATALOG", target: "#platform", id: "platform" },
];

export default function Navbar() {
  const { count, openCart } = useCart();
  const [soundOn, setSoundOn] = useState(false);

  const toggleSound = () => {
    const next = !soundOn;
    setSoundOn(next);
    setHum(next);
    if (next) beep(660, 0.08);
  };

  return (
    <nav
      data-testid="main-nav"
      className="fixed inset-x-0 top-0 z-40 border-b border-cyanx/15 bg-black/70 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToId("#entrance")}
          className="title-tall transition-opacity duration-200 hover:opacity-75"
        >
          <span className="crt-text block font-poster text-3xl leading-none">GUMZ</span>
        </button>

        <div className="hidden items-center gap-2 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => {
                beep(520, 0.05);
                scrollToId(l.target);
              }}
              className="btn-y2k px-3 py-1.5 text-[10px] tracking-[0.25em]"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            data-testid="sound-toggle"
            onClick={toggleSound}
            aria-label="Toggle ambient sound"
            className="btn-y2k p-2"
          >
            {soundOn ? <Volume2 size={15} /> : <VolumeX size={15} />}
          </button>
          <button
            data-testid="cart-drawer-toggle"
            onClick={() => {
              beep(740, 0.06);
              openCart();
            }}
            className="btn-y2k relative px-3 py-2"
          >
            <ShoppingCart size={15} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center bg-danger font-mono text-[10px] font-bold text-white"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
}
